import React, { useEffect, useState } from 'react'
import { Box, Heading, Grid, GridItem, Link } from '@chakra-ui/react'
import {
  RiFacebookBoxFill,
  RiGlobalFill,
  RiInstagramFill,
  RiLink,
  RiLinkedinBoxFill
} from 'react-icons/ri'
const SocialList = ({ fontFamily, currentSocial, currentWeb }) => {
  const [socialMedia, setSocialMedia] = useState([])
  useEffect(() => {
    const arr = []
    currentSocial.forEach((item, i) => {
      const keyNameSlug = Object.keys(item)
      const slug = keyNameSlug.toString()
      // const value = item[keyNameSlug]
      const value = currentSocial[i].url
      arr.push({
        name: slug.charAt(0).toUpperCase() + slug.slice(1),
        slug: slug === 'other' ? `${slug}${i}` : slug,
        placeholder: `www.${slug}.com/reworth`,
        value: value
      })
    })
    setSocialMedia(arr)
  }, [])
  const renderIcon = (type) => {
    if (type === 'web') {
      return <RiGlobalFill color='#001B69' fontSize='1.2rem' />
    } else if (type === 'facebook') {
      return <RiFacebookBoxFill color='#001B69' fontSize='1.2rem' />
    } else if (type === 'instagram') {
      return <RiInstagramFill color='#001B69' fontSize='1.2rem' />
    } else if (type === 'linkedin') {
      return <RiLinkedinBoxFill color='#001B69' fontSize='1.2rem' />
    } else {
      return <RiLink color='#001B69' fontSize='1.2rem' />
    }
  }

  const handleUrl = (link) => {
    if (
      link &&
      (link.indexOf('http://') !== -1 || link.indexOf('https://') !== -1)
    ) {
      return link
    } else {
      return `https://${link}`
    }
  }

  const renderList = (item, i) => {
    return (
      <Link
        key={i}
        href={handleUrl(i === 'web' ? currentWeb : item.value)}
        target='_blank'
        rel='noreferrer'
        isExternal
        w='100%'
        textunderline='true'
      >
        <Box
          w='100%'
          display='flex'
          alignItems='center'
          justifyContent='flex-start'
          flexDirection='row'
          borderBottom='1px solid #00000061'
          pb='0.5rem'
          pt='5.2px'
          cursor='pointer'
        >
          <Grid w='100%' templateColumns='repeat(12, 2fr)' pt='.8rem'>
            <GridItem
              colSpan={1}
              display='flex'
              alignItems='center'
              justifyContent='flex-start'
              flexDirection='row'
            >
              {renderIcon(i === 'web' ? i : item.slug)}
            </GridItem>
            <GridItem
              colSpan={11}
              display='flex'
              alignItems='center'
              justifyContent='flex-start'
              wordBreak='break-all'
            >
              <Heading
                pl='0.5rem'
                color='brand.secondaryDark'
                fontSize={['14px', '14px', '14px', '14px']}
                margin='0px'
                fontFamily={fontFamily}
                fontWeight='500'
              >
                {i === 'web'
                  ? `${currentWeb.split('/')[0]}${
                      currentWeb.split('/')[2]
                        ? '//' + currentWeb.split('/')[2] + '/'
                        : ''
                    }`
                  : item.value}
              </Heading>
            </GridItem>
          </Grid>
        </Box>
      </Link>
    )
  }
  console.log(socialMedia)
  console.log(currentWeb)
  return (
    <Box
      w='100%'
      display='flex'
      alignItems='center'
      justifyContent='center'
      flexDirection='column'
    >
      {socialMedia.map((item, i) => {
        return renderList(item, i)
      })}
      {currentWeb !== '' || currentWeb !== undefined
        ? renderList(currentWeb, 'web')
        : null}
    </Box>
  )
}

export default SocialList
